<template>
  <div :style="styleObj" class="border-r12 border-gray widget-table" :key="compIndex">
    <div class="widget-time" v-show="dateRang && dateRang.length > 0">
			<TagDateRange size="small" v-model="dateRang"  @change="onChange"></TagDateRange>
    </div>
    <!-- title -->
    <div class="table-title" :style="titleStyle">
      <span>{{ optionsSetUp.titleText }}</span>
    </div>
    <!-- //普通的 normal,
    //对比 compare,
    //总和 summation,
    //平均值 average,
    //差值 difference,
    //差值百分比 percentageDiff -->
    <div v-if="hackReset  && list &&  !Number.isNaN(list.length) " class="txtScroll-top">
      <!--表头-->
      <div class="title" :style="tableRowHeight()">
        <div class="title-box" ref="headTitle">
          <TableHeader ref="tableHeader" v-for="(item, index) in header" :index="index" :key="index" :filterConditions="filterConditions" :item="item" :tableRowHeight="tableRowHeight" @filterConfirm="filterConfirm" @handleSort="handleSort"
            :style="[headerTableStlye,  tableRowHeight(), tableSetStyle(item)]"
          ></TableHeader>
        </div>
      </div>
      <!--数据-->
      <div class="bd" @scroll="bdScroll">
        <ul class="infoList" v-if="list.length">
          <li v-for="(item, index) in list"  :key="index" :style="[tableRowHeight(),]">
            <div
              v-for="(itemChild, idx) in header"
              :key="idx"
              class="table-cell flex-child-use-width"
              :class="[getCellClassName(item, itemChild), itemChild.showType === 'IMAGE' ? 'image-cell' : '']"
              :style="[
                bodyTableStyle,
                bodyTable(index),
                tableRowHeight(),
                tableSetStyle(itemChild),
              ]"
            >
              <a-tooltip placement="topLeft">
                <span slot="title">
                  <a href="javascript:;" class="tooltip-link" v-if="itemChild.example" @click="turnToMedia(item.data, itemChild.field)">{{item.data[itemChild.field]}}</a>
                  <a :href="item.data[itemChild.field]" target="_blank" v-else-if="isHttp(item.data[itemChild.field])">{{item.data[itemChild.field]}}</a>
                  <span v-else>{{item.data[itemChild.field]}}</span>
                </span>
                <span class="body-cell" :class="item.rowType === 'summation' ? 'bold' : ''">
                  <template v-if="itemChild.showType === 'IMAGE'">
                    <img
                      v-if="isHttp(item.data[itemChild.field])"
                      class="thumb-img"
                      :src="item.data[itemChild.field]"
                      alt=""
                      @click.stop="openImagePreview(item.data[itemChild.field])"
                    />
                    <span v-else>-</span>
                  </template>
                  <template v-else>
                    {{ item.data[itemChild.field] === undefined || item.data[itemChild.field] === null ? '-' : (itemChild.dataType === 'NUMBER'  && item.rowType !== 'percentageDiff' ? $getThousandths(item.data[itemChild.field]) : item.data[itemChild.field])}}
                  </template>
                </span>
              </a-tooltip>
            </div>
          </li>
        </ul>
        <div class="cont-no-data" style="height: 100%" v-else>
          <div>
            <img class="no-data-img" src="@/assets/images/empty.svg" alt="">
            <p class="mt-16 no-data-text">暂无数据</p>
          </div>
        </div>
      </div>
      <div class="pagination bg-white pt8 pb8">
        <a-pagination
          :current="params.pageNum"
          :page-size="params.pageSize"
          :show-total="total => `共 ${params.total} 条`"
          :total="params.total"
          @change="handlePageChange"
          size="small"
        ></a-pagination>
        <span class="page-size">{{params.pageSize}}条/页</span>
      </div>
    </div>
    <div class="df-center h-100p" v-else>
      <a-empty />
      <div></div>
    </div>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      :width="860"
      centered
      @cancel="previewVisible = false"
      wrapClassName="img-preview-modal"
    >
      <img :src="previewSrc" alt="" style="width: 100%; display: block" />
    </a-modal>
  </div>
</template>
<script>
import vue from "vue";
import { mapGetters } from "vuex";
import VueSuperSlide from "vue-superslide";
vue.use(VueSuperSlide);
import TagDateRange from "@/components/TagDateRange";
import TableHeader from "./tableHeader";
import { getTargetAccountName } from '@/api/template'

export default {
  props: {
    value: Object,
    ispreview: Boolean,
    compIndex: Number,
  },
  components: {
    TagDateRange,
    TableHeader
  },
  data() {
    return {
      hackReset: true,
      options: {
        titCell: ".hd ul",
        mainCell: ".bd ul",
        effect: "topLoop",
        autoPage: true,
        //effect: "top",
        autoPlay: true,
        vis: 10,
        rowHeight: "50px",
      },
      tableId: 0,
      header: [],
      list: [],
      optionsSetUp: {},
      optionsPosition: {},
      optionsData: {},
      orders: [],
      params: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      isCompare: false,
      compTemplate:{},
      filterConditions: [],
       // 时间组件
      dateRang: [],
      timeSelector: "",
      previewVisible: false,
      previewSrc: "",
    };
  },
  inject: ["isbase", "getDashboardDynamicData","getIndex", "widgetUpdate", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    ...mapGetters({
      tableHeaderData: "getTableHeaderData",
      tablePosition: "getCurrentTablePosition",
      currentTempIndex: "getCurrentTempIndex",
      currentComponentCache: "getCurrentComponentCache",
    }),
    titleStyle(){
      return {
        fontSize: this.optionsSetUp.textFontSize + "px",
        color: this.optionsSetUp.textColor,
        textAlign: this.optionsSetUp.titleTextAlign || 'left',
      };
    },
    styleObj() {
      const allStyle = this.optionsPosition;
      return {
        position: this.ispreview ? "absolute" : "static",
        width: allStyle.width + "px",
        height: allStyle.height + "px",
        left: allStyle.left + "px",
        top: allStyle.top + "px",
        background: this.optionsSetUp.tableBgColor || "#FFFFFF",
        overflow: 'hidden'
      };
    },
    headerTableStlye() {
      const headStyle = this.optionsSetUp;
      return {
        "font-size": headStyle.fontSize + "px",
        "border-style": headStyle.isLine ? "solid" : "none",
        "border-width": headStyle.borderWidth + "px",
        "border-color": headStyle.borderColor || '#E1E8F9',
        "border-bottom": '1px solid #E1E8F9',
        display: headStyle.isHeader ? "block" : "block",
        "display": "flex",
        color: headStyle.headColor,
        "background-color": headStyle.headBackColor || '#FBFCFE',
      };
    },
    bodyTableStyle() {
      const bodyStyle = this.optionsSetUp;
      return {
        "font-size": bodyStyle.fontSize + "px",
        // "border-style": bodyStyle.isLine ? "solid" : "none",
        "border-width": bodyStyle.borderWidth + "px",
        "border-color": bodyStyle.borderColor,
        color: bodyStyle.bodyColor,
        "background-color": bodyStyle.tableBgColor,
      };
    },
    hasImageColumn() {
      return (this.header || []).some(v => v.showType === 'IMAGE')
    },
  },
  watch: {
    value: {
      handler(val) {
        this.optionsPosition = val.position;
        console.log(val.setup, '=================')
        if(this.optionsData === val.data && JSON.stringify(this.optionsSetup) === JSON.stringify(val.setup)) return;
        this.optionsSetUp = val.setup;
        this.optionsData = val.data;
        this.params.pageSize = this.optionsSetUp.pageSize || 10
        this.$store.commit("modelDesign/SET_CURRENT_TABLE_POSITION_RES", val.position);
        if(!this.ispreview || (this.ispreview&&this.isContCompDate(this.optionsData))) {
          this.initData();
          this.editorDataSet();
        }
      },
      deep: true,
      immediate: true
    },
    currentTempIndex(val) {
      // 便于编辑的时候，第一次applyData 时取配置里面的列配置
       const curIndex = this.currentTempIndex
      this.$set(this.compTemplate, curIndex, 0)
    },
  },
  methods: {
    openImagePreview(src) {
      this.previewSrc = src
      this.previewVisible = true
    },
    turnToMedia(data, field) {
      let contextData = JSON.parse(JSON.stringify(this.optionsData.dynamicData.contextData))
      contextData.conditions = contextData.conditions.concat(contextData.filterConditions || [])
      contextData.conditions.push({
        name: field,
        op: "eq",
        value: data[field]
      })
      getTargetAccountName({
        ...this.getDatasource(contextData),
        globalOptions: {
          globalDataSource: this.dashbordData.datasource,
          globalTableId: this.dashbordData.tableId,
          globalFilterType: this.dashbordData.filterType,
          globalAccountIds: this.dashbordData.accountIds,
          filterCondition: this.getFilterCondition(),
        },
        pageNum: this.params.pageNum,
        pageSize: this.params.pageSize,
      }, field).then((res) => {
        if(res.data) {
          window.open(res.data, '_blank')
        }
      })
    },
    isHttp(s) {
      return typeof(s) === "string"&&s.indexOf('http') > -1
    },
    bdScroll(e,a) {
      let num = e.target.scrollLeft
      this.$refs.headTitle.scrollLeft = num
    },
    filterSearch() {
      this.params.pageNum = 1;
      this.handlerData();
    },
    onChange(val, timeSelector) {
      if(this.ispreview){
        const dataSet = this.optionsData.dynamicData.contextData;
        dataSet.dateRang.from = val[0];
        dataSet.dateRang.to = val[1];
        dataSet.dateRang.timeSelector = timeSelector;
        this.params.pageNum = 1;
        this.handlerData();
      }
    },
    filterConfirm(obj, flag) {
      let arr = this.optionsData.dynamicData.contextData.filterConditions || []
      let index = arr.findIndex(v => v.id === obj.id)
      if(flag) {
        index > -1?arr[index] = obj:arr.push(obj)
      } else {
        if(index > -1) {
          arr.splice(index, 1)
        } else {
          return
        }
      }
      this.optionsData.dynamicData.contextData.filterConditions = arr
      this.filterConditions = arr
      this.params.pageNum = 1
      this.handlerData();
    },
    editorDataSet(){
      // 获取数据的配置项；
      const dataSet = this.optionsData.dynamicData?.contextData || {};
      this.isCompare = dataSet?.calc?.compare || false;
      // 设置日期响应
      if(dataSet?.dateRang?.from && dataSet?.dateRang?.to){
        let dateRang = [];
        dateRang[0] = dataSet.dateRang.from;
        dateRang[1] = dataSet.dateRang.to;
        this.$set(this.dateRang, 0, dateRang[0])
        this.$set(this.dateRang, 1, dateRang[1])
        this.timeSelector = dataSet.dateRang.timeSelector
      }else {
        this.dateRang = [];
        this.timeSelector = ''
      }
    },
    // 预览时调用的方法
    async previewInit(data) {
      this.isContCompDate(this.optionsData) ? null : this.setTableFromResponse(data);
    },
    async initData() {
      this.handlerRollFn();
      // 编辑表格时用到该方法；
      let query = this.$route.query
      let isBase = query.isbase || (this.isbase?this.isbase():false)
      if(!isBase) {
        await this.handlerData();
      }
      this.setTableHeader();
      this.options.vis = this.optionsSetUp.vis || 10;
    },
    setTableHeader(){
      if(this.optionsSetUp?.dynamicAddTable){
        this.header = this.$deepclone(this.optionsSetUp.dynamicAddTable);
      }
      this.$forceUpdate()
    },
    handlePageChange(pageNum, pageSize) {
      this.params.pageNum = pageNum;
      this.params.pageSize = pageSize;
      this.optionsData.dynamicData.contextData.pageNum = pageNum;
      this.optionsData.dynamicData.contextData.pageSize = pageSize;
      this.handlerData(this.ispreview, true);
    },
    handlerRollFn() {
      const options = this.options;
      const rollSet = this.optionsSetUp;
      options.autoPlay = rollSet.isRoll;
      options.effect = rollSet.effect || "topLoop";
      options.interTime = rollSet.interTime;
      options.delayTime = rollSet.delayTime;
      options.scroll = rollSet.scroll;
      this.options = options;
      this.hackResetFun();
    },
    handlerData(ispreview, modifyPageNum) {
      const tableData = this.optionsData;
      if (tableData.dataType == "dynamicData") {
        if (this.ispreview) {
          tableData.dynamicData.chartProperties.ispreview = true;
        }
        // 如果是新的数据，则还是利用旧数据进行渲染；
        if (tableData.dynamicData && tableData.dynamicData.contextData) {
          // 对于不是切换分页调用的表格接口，重置为首页
          this.handlerDynamicData(tableData.dynamicData, tableData.refreshTime);
        }
      }
    },
    // 清除之前的选择
    clearTableSort(curIndex) {
      this.header.map((item, index) => {
        if (index !== curIndex && item.sortable !== "normal") {
          this.header[index].sortable = "normal";
        }
      });
    },
    handleSort(item, index) {
      this.clearTableSort(index);
      if (item.sortable === "normal") {
        this.header[index].sortable = "asc";
        this.getTableClassName(item, index, "asc");
      } else if (item.sortable === "asc") {
        this.header[index].sortable = "desc";
        this.getTableClassName(item, index, "desc");
      } else if (item.sortable === "desc") {
        this.header[index].sortable = "normal";
        this.getTableClassName(item, index, "normal");
      }
      this.orders = this.getOrderParams(item)
      this.optionsData.dynamicData.contextData.orders = this.getOrderParams(item)
      this.handlerData(this.ispreview);
    },
    getOrderParams(item) {
      return item.sortable !== "normal"?[{
        field: item.field,
        asc: item.sortable === "asc"
      }]:[]
    },
    getTableClassName(item, sortFileter) {
      // sortable（排序）字段的值： normal 没有排序， asc 升序， desc 降序;
      return item.sortable === sortFileter?"active":'';
    },
    handlerDynamicData(val, refreshTime) {
      if (!val) return;
      if (this.ispreview) {
        this.editorDataSet();
        this.getEchartData(val);
      } else {
        if (!val || !val.chartProperties || val.chartProperties.isVerified === false)
          return;
        this.getEchartData(val);
      }
    },
    getEchartData(val) {
      let contextData = JSON.parse(JSON.stringify(val.contextData))
      contextData.conditions = contextData.conditions.concat(contextData.filterConditions || [])
      const data = this.queryEchartsData(
        contextData,
        val.params,
        val.chartProperties,
        // 表格分页参数
        this.params
      );
      data.then((res) => {
        if (this.ispreview) {
          this.$store.commit("modelDesign/SET_VIEW_LOADING", false);
        }
        console.log(res, '```````````````````')
        this.setTableFromResponse(res);
      });
    },
    // 依据后端返回的result 处理data,渲染组件
    setTableFromResponse(res) {
      const cloneRes = this.$deepclone(res);
      this.$store.commit("modelDesign/SET_DYNAMIC_DATA_RES", cloneRes);
      const { result, fields, dateRang, page, table } = res;
      this.list = result || [];
      this.header = fields || [];
      this.tableId = table.id || 0;
      const dynamicAddTable = this.optionsSetUp.dynamicAddTable || [];
      if(this.ispreview){
        this.$forceUpdate();
        this.header = dynamicAddTable.length > 0?dynamicAddTable:fields;
      }else {
        // 缓存的时候使用表格列宽
        // 对于缓存接口后的数据重新切回去时的，列不更新问题
        const newFields = this.$deepclone(fields);
        this.setHeaderData(this.setTableFieldList(dynamicAddTable, newFields))
      }
      this.params.pageNum = page.current;
      this.params.total = page.recordCount;
      this.params.pageSize = page.size;
      this.hackResetFun();
    },
    // 设置head值
    setHeaderData(arr) {
      this.optionsSetUp.dynamicAddTable = arr
      this.widgetUpdate('setup', {
        dynamicAddTable: arr
      }, this.compIndex)
      this.header = this.$deepclone(arr);
    },
    setTableFieldList(dynamicAddTable, valList) {
      if(valList instanceof Array) {
        const tableWidth = this.tablePosition.width - 56;
        const itemWidth = this.$fixedMath(tableWidth/valList.length, 2);
        let arr = valList.filter(val => !dynamicAddTable.find(v => v.id === val.id))
        let dimensions = arr.filter(val => val.type.indexOf('dimension') > -1)
        let merics = arr.filter(val => val.type.indexOf('dimension') === -1)
        let adds = dynamicAddTable.filter(val => valList.find(v => v.id === val.id)).concat(merics)
        if(dimensions.length) {
          let index = adds.findLastIndex(val => val.type.indexOf('dimension') > -1)
          adds.splice(index + 1, 0, ...dimensions)
        }
        return adds.map((item) => {
          let obj = valList.find(v => v.id === item.id)
          return {
            ...obj,
            ...item,
            width: item?.width || itemWidth,
            widthType: "normal",
          }
        })
      } else {
        return []
      }
    },
    // vue hack 之强制刷新组件
    hackResetFun() {
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    },
    // 计算 奇偶背景色
    bodyTable(index) {
      return {
        "background-color": index % 2?this.optionsSetUp.eventColor:this.optionsSetUp.oldColor
      };
    },
    getCellClassName(item, itemChild){
      let numParse = parseFloat(item.data[itemChild.field])
      if(!isNaN(numParse) && (item.rowType == "difference" || item.rowType == "percentageDiff")) {
        return numParse < 0?'gl-red':'gl-green'
      }
      // const num = Number(item.data[itemChild.field])
      // let numParse = parseInt(num)
      // const numParseLen = numParse.toString().length;
      // if(numParseLen >=2 && numParseLen  <8){
      //   return `cell-${8- numParseLen+ 1}`
      // }else if(numParseLen >=8){
      //   return 'cell-1'
      // }
    },
    tableRowHeight() {
      const cfgHeight = Number(this.optionsSetUp.rowHeight) || 0
      const rowHeight = this.hasImageColumn ? Math.max(cfgHeight, 50) : cfgHeight
      return {
        height: rowHeight ? `${rowHeight}px` : this.optionsSetUp.rowHeight,
        "line-height": rowHeight ? `${rowHeight}px` : this.optionsSetUp.rowHeight,
      };
    },
    getRowAlign(item){
      return item.dataType === 'NUMBER'?'right':this.optionsSetUp.textAlign;
    },
    getRowFlexAlign(item){
      let type = {
        left: 'start',
        right: 'end',
      }
      return item.dataType === 'NUMBER'?'end':(type[this.optionsSetUp.textAlign] || 'center')
    },
    // 外部设置样式
    tableSetStyle(item){
      return {
        flex:1,
        'flex-basis': item.width ? `${item.width}px` : '',
        'min-width': item.width ? `${item.width}px` : '',
        'text-align': this.getRowAlign(item),
        'justify-content': this.getRowFlexAlign(item),
      }
    },
  },
  beforeDestroy() {
    const curIndex = this.currentTempIndex
    this.$set(this.compTemplate, curIndex, 0)
  },
};
</script>
<style lang="less">
.widget-table {
  padding: 24px;
  padding-top: 56px;
  .table-title {
    position: absolute;
    left: 0px;
    top: 16px;
    line-height: 24px;
    padding: 0 24px;
    width: 100%;
  }
  /* 本例子css */
  .txtScroll-top {
    position: relative;
    overflow-x: auto;
    height: 100%;
    display: flex;
    flex-flow:column nowrap;
    .bd {
      width: 100%;
      overflow-y: scroll;
      flex-grow: 1;
    }
    .infoList{
      padding: 0 !important;
      margin-bottom: 0;
      .compare-rwo {
        background: #F3F6FE;
      }
      li {
        height: 50px;
        line-height: 50px;
        display: flex;
        color: #2D3446;
        flex-direction: row;
        .table-cell{
          border-top: 1px solid #E1E8F9;
        }
        & > div {
          width: 100%;
          padding-left: 12px;
        }
      }
    }
  }
  .title {
    width: 100%;
    padding-right: 6px;
  }
  .title-box {
    flex-direction: row;
    display: flex;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      height: 0;
    }
  }
  .title-box > div {
    display: flex;
    font-weight: 500;
    color: #677392;
    width: 100%;
    padding-left: 12px;
  }

  .pagination {
    text-align: right;
    .page-size {
      line-height: 24px;
      color: #677392;
      font-size: 14px;
      vertical-align: middle;
      font-variant: tabular-nums;
    }
    .ant-pagination {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
  }
  .table-cell{
    overflow: hidden;
      /*文本不会换行*/
      white-space: nowrap;
      /*当文本溢出包含元素时，以省略号表示超出的文本*/
      text-overflow: ellipsis;
  }
  .image-cell {
    overflow: visible;
    white-space: normal;
    .body-cell {
      display: inline-flex;
      align-items: center;
      line-height: normal;
      height: 100%;
    }
  }
  .thumb-img {
    width: auto;
    max-width: 100%;
    height: 50px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #E1E8F9;
    cursor: pointer;
    vertical-align: middle;
  }
  .cell-1{
    background:  #0D8417;
  }
  .cell-2{
    background:  #199B28;
  }
  .cell-3{
    background:  #22a035;
  }
  .cell-4{
    background:  #42B853;
  }
  .cell-5{
    background:  #6FC87B;
  }
  .cell-6{
    background:  #C7EACC;
  }
  .cell-7{
    background:  #F2FAF3;
  }
  .cell-8{
    background:  #FAFDFB ;
  }
  .bold{
    font-weight: bold;
  }
}
.tooltip-link {
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
}
</style>
